import SiteNav from './components/SiteNav';
import Hero from './components/Hero';
import TodayIndex from './components/TodayIndex';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryZones from './components/CategoryZones';
import ExclusiveLeads from './components/ExclusiveLeads';
import GroupExchange from './components/GroupExchange';
import RhythmBand from './components/RhythmBand';
import JoinCTA from './components/JoinCTA';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-sans">
      <SiteNav />
      <main className="w-full flex-1">
        <Hero />
        <TodayIndex />
        <FeaturedGrid />
        <CategoryZones />
        <ExclusiveLeads />
        <GroupExchange />
        <RhythmBand />
        <JoinCTA />
      </main>
      <SiteFooter />
    </div>
  );
}